/* eslint-disable max-len */
import React from 'react';
import { IconsProps } from './Icons.type';

export const GiftIcon: React.FC<IconsProps> = ({ fill = 'white' }) => (
    <svg
        width="24"
        height="23"
        viewBox="0 0 24 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.5 11.5V17.125C19.5 19.1969 17.8219 20.875 15.75 20.875H8.25C6.17812 20.875 4.5 19.1969 4.5 17.125V11.5C4.5 10.9844 4.92188 10.5625 5.4375 10.5625H7.28437C7.8 10.5625 8.22187 10.9844 8.22187 11.5V14.4438C8.22187 15.1375 8.60625 15.775 9.21562 16.1031C9.4875 16.2531 9.7875 16.3281 10.0969 16.3281C10.4531 16.3281 10.8094 16.225 11.1188 16.0187L12.0094 15.4375L12.8344 15.9906C13.4062 16.375 14.1375 16.4219 14.7469 16.0937C15.3656 15.7656 15.75 15.1375 15.75 14.4344V11.5C15.75 10.9844 16.1719 10.5625 16.6875 10.5625H18.5625C19.0781 10.5625 19.5 10.9844 19.5 11.5Z"
            fill={fill}
        />
        <path
            d="M20.9062 6.8125V7.75C20.9062 8.78125 20.4094 9.625 19.0312 9.625H4.96875C3.53438 9.625 3.09375 8.78125 3.09375 7.75V6.8125C3.09375 5.78125 3.53438 4.9375 4.96875 4.9375H19.0312C20.4094 4.9375 20.9062 5.78125 20.9062 6.8125Z"
            fill={fill}
        />
        <path
            d="M11.6631 4.9376H6.48809C6.16934 4.59072 6.17872 4.05635 6.51622 3.71885L7.84747 2.3876C8.19434 2.04072 8.76622 2.04072 9.11309 2.3876L11.6631 4.9376Z"
            fill={fill}
        />
        <path
            d="M17.5031 4.9376H12.3281L14.8781 2.3876C15.225 2.04072 15.7969 2.04072 16.1437 2.3876L17.475 3.71885C17.8125 4.05635 17.8219 4.59072 17.5031 4.9376Z"
            fill={fill}
        />
        <path
            d="M13.8465 10.5625C14.3621 10.5625 14.784 10.9844 14.784 11.5V14.4344C14.784 15.1844 13.9496 15.6344 13.3309 15.2125L12.4871 14.65C12.1777 14.4437 11.7746 14.4437 11.4559 14.65L10.5746 15.2312C9.95586 15.6437 9.13086 15.1937 9.13086 14.4531V11.5C9.13086 10.9844 9.55273 10.5625 10.0684 10.5625H13.8465Z"
            fill={fill}
        />
    </svg>
);
